import React from 'react';
import {withRouter} from "react-router-dom";
import {RefluxListener} from "sp-react-commons";

import * as MoviesActions from "../core/MoviesActions";
import Loader from "../components/Loader";
import MovieDetails from "../components/MovieDetails";


@withRouter
@RefluxListener
export default class MovieDetailsPage extends React.Component {

    state = {
        movie : null
    };

    componentDidMount() {
        this.listenTo(MoviesActions.getMovie.completed, this.onMovie);
        const id = this.props.match.params.id;
        MoviesActions.getMovie(id);
    }

    componentDidUpdate(prevProps) {
        window.pymChild && window.pymChild.sendHeight();
        if(prevProps.match.params.id !== this.props.match.params.id) {
            const id = this.props.match.params.id;
            MoviesActions.getMovie(id);
        }
    }

    get loading() { return !this.state.movie; }

    onMovie = ({ movie }) => {
        this.setState({ movie }, () => {
            this.scrollToDetails();
        });
    };

    scrollToDetails() {
        if( $( document ).scrollTop() > $( '.movie-details-page' ).offset().top ) {
            return $( 'html, body' ).animate( { scrollTop: $( '#movies' ).offset().top }, 500 );
        }
    }

    render() {

        if(this.loading) {
            return (
                <Loader/>
            );
        }

        return (
            <MovieDetails movie={this.state.movie}/>
        );
    }
}



// WEBPACK FOOTER //
// ./js/movies/pages/MovieDetailsPage.jsx